import { render } from "./IncomeGrid.vue?vue&type=template&id=b9776708"
import script from "./IncomeGrid.vue?vue&type=script&lang=js"
export * from "./IncomeGrid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__